import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const TermsConditionsPage = () => {
  return (
    <div data-testid="terms-conditions-page" className="min-h-screen bg-[#FAFAF8]">
      <Header />
      <main>
        {/* Hero */}
        <section className="bg-[#2D5A27] py-16 md:py-20">
          <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
            <h1
              data-testid="terms-conditions-headline"
              className="font-heading text-3xl md:text-4xl lg:text-5xl text-white font-bold"
            >
              Terms & Conditions
            </h1>
            <p className="text-white/80 mt-4">Last updated: December 2025</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-12 md:py-16">
          <div className="container mx-auto max-w-4xl px-4 md:px-6 lg:px-8">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
              <div className="prose prose-lg max-w-none text-[#4B5563]">
                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  1. Agreement to Terms
                </h2>
                <p className="mb-6">
                  By accessing our website or using CasaCurate Store's landscaping services, you agree to be bound by these Terms and Conditions. If you do not agree to all terms, please do not use our services.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  2. Services Description
                </h2>
                <p className="mb-6">
                  CasaCurate Store provides landscaping and gardening services including but not limited to landscape design, lawn installation, garden maintenance, irrigation setup, and related services. All services are subject to availability and the terms outlined in individual service agreements.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  3. Estimates and Pricing
                </h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li>All estimates are provided free of charge and are valid for 30 days from the date issued.</li>
                  <li>Pricing varies based on property size, materials, project scope, and specific requirements.</li>
                  <li>Written estimates will be provided before any work begins.</li>
                  <li>Additional work beyond the original scope may result in additional charges, which will be communicated before proceeding.</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  4. Payment Terms
                </h2>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li>A deposit may be required to begin work on certain projects.</li>
                  <li>Final payment is due upon completion of services unless otherwise agreed in writing.</li>
                  <li>We accept cash, check, and major credit cards.</li>
                  <li>Late payments may be subject to interest charges.</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  5. Scheduling and Access
                </h2>
                <p className="mb-6">
                  Clients must provide reasonable access to the property for scheduled services. If access is not available at the scheduled time, a rescheduling fee may apply. We will make reasonable efforts to complete work within agreed timeframes, subject to weather conditions and other factors beyond our control.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  6. Warranty and Guarantees
                </h2>
                <p className="mb-6">
                  We stand behind our workmanship and will address any issues that arise from our installation or services within a reasonable timeframe. Plant and material warranties are subject to manufacturer terms. We do not guarantee plant survival beyond factors within our control.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  7. Limitation of Liability
                </h2>
                <p className="mb-6">
                  CasaCurate Store shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from our services. Our total liability shall not exceed the amount paid for the specific service in question.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  8. Property Damage
                </h2>
                <p className="mb-6">
                  We take precautions to protect your property during service. However, we are not responsible for damage to underground utilities, irrigation systems, or other hidden features not disclosed to us prior to work. Clients should mark or disclose any known underground features.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  9. Intellectual Property
                </h2>
                <p className="mb-6">
                  All content on this website, including text, graphics, logos, and images, is the property of CasaCurate Store and protected by copyright laws. You may not reproduce, distribute, or use our content without written permission.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  10. Governing Law
                </h2>
                <p className="mb-6">
                  These Terms shall be governed by the laws of the State of California. Any disputes shall be resolved in the courts of Los Angeles County, California.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  11. Contact Information
                </h2>
                <p className="mb-4">
                  For questions about these Terms, please contact us:
                </p>
                <p className="mb-2"><strong>CasaCurate Store</strong></p>
                <p className="mb-2">1513 Sunset Boulevard, Los Angeles, CA 90027</p>
                <p className="mb-2">Phone: +1-771-1871-113</p>
                <p>Email: info@casacurate.store</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
